import {css} from '@emotion/react'
import React, {useRef} from 'react'
import {Mousewheel, Navigation} from "swiper"
import "swiper/css"
import "swiper/css/navigation"
import {Swiper, SwiperSlide} from "swiper/react"
import {Spacing} from '../../styles/spacing'
import {isDesktop} from "../../styles/utils";

const BREAK_POINTS = {
  default: {
    0: {
      slidesPerView: 1.1
    },
    400: {
      slidesPerView: 1.2,
    },
    550: {
      slidesPerGroup: 2,
      slidesPerView: 2,
    },
    1024: {
      slidesPerGroup: 3,
      slidesPerView: 3,
    }
  },
  large: {
    // when window width is >= 320px
    0: {
      slidesPerView: 1.02,
    },
    // when window width is >= 640px
    600: {
      slidesPerGroup: 2,
      slidesPerView: 2,
    },
    // when window width is >= 640px
    1024: {
      slidesPerGroup: 3,
      slidesPerView: 3,
    }
  }
}
const SliderContainer = css`
  transform: translateX(0px);
  margin: 10px 0px;
  .swiper-button-disabled {
    display: none;
  }
  .swiper-button-prev, .swiper-button-next {
    color: #1C1C1C;
    transform: translateY(5px);
  }

  @media (min-width: 1200px) {
    margin: 10px -30px;
    padding: 0 30px;
    .swiper-button-prev {
      left: -4px;
    }

    .swiper-button-prev,
    .swiper-button-next {
      transform: translateY(-10px);
    }
  }
`

const navigationStyle = css`
  .swiper-margin {
    display: block;
    padding: 2px;
  }
`

const Wrapper = React.forwardRef(({isMobile, children}, ref) => {
  const [nextRef, prevRef] = ref.current

  if (!isMobile) {
    return (
      <div css={SliderContainer}>
        {/* The following div is due to react Slider that has a bug and destroy classes in the first div*/}
        <div className="fake-div "/>
        <div ref={prevRef} className="swiper-button-prev"/>
        {children}
        <div ref={nextRef} className="swiper-button-next"/>
      </div>)
  }
  return <div css={[SliderContainer]}>{children}</div>
})

export const Slider = ({children, key, cardSize = 'default', hideNavigation = false, ...props}) => {
  const isMobile = !isDesktop()
  const nextBtnRef = useRef(null)
  const prevBtnRef = useRef(null)
  const wrapperRef = useRef([nextBtnRef, prevBtnRef])
  const numberOfCards = React.Children.count(children)
  return (
    <Wrapper isMobile={isMobile || numberOfCards < 4 || hideNavigation} hideNavigation ref={wrapperRef}>
      <Swiper
        css={[navigationStyle, isMobile && Spacing.Layout.full]}
        navigation={!isMobile && {
          nextEl: nextBtnRef.current,
          prevEl: prevBtnRef.current
        }}

        onBeforeInit={(swiper) => {
          if (isMobile) return
          swiper.params.navigation.prevEl = prevBtnRef.current;
          swiper.params.navigation.nextEl = nextBtnRef.current;
        }}
        mousewheel={!isMobile && { forceToAxis: true } }
        modules={[Mousewheel, Navigation]}
        breakpoints={BREAK_POINTS[cardSize]}
        spaceBetween={16}
        slidesOffsetBefore={isMobile ? 10 : 4}
        slidesOffsetAfter={isMobile ? 10 : 4}
        {...props}
      >
        {React.Children.map(children, (card, index) => (<SwiperSlide key={index}>{card}</SwiperSlide>))}
        <span className="swiper-margin" slot="container-start"/>
        <span className="swiper-margin" slot="container-end"/>
      </Swiper>
    </Wrapper>
  )
}

